import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header-content" }
const _hoisted_2 = {
  key: 0,
  class: "w-full h-[60px] bg-black-950 flex justify-center sticky top-0 z-[999] h-[${HEADER_HEIGHT}px]"
}
const _hoisted_3 = { class: "siteHeader" }
const _hoisted_4 = {
  key: 0,
  class: "siteHeaderPanel flex items-center"
}
const _hoisted_5 = { class: "text-left" }
const _hoisted_6 = { class: "flex items-center relative user-name" }
const _hoisted_7 = { class: "font-[800] mr-[0.16rem] cursor-pointer" }
const _hoisted_8 = { class: "absolute top-[20px] bg-[#fff] p-[1.25rem] w-[14.4rem] right-0 user-name-handle" }
const _hoisted_9 = { class: "flex items-center pb-[1rem] border-b-[0.0625rem] border-[#F0F0F0]" }
const _hoisted_10 = { class: "text-[0.875rem] font-bold text-[#000] ml-[0.5rem] line-clamp-1" }
const _hoisted_11 = {
  key: 1,
  class: "flex items-center text-left"
}
const _hoisted_12 = {
  key: 0,
  className: "h-[3rem] bg-[#000] flex items-center justify-between px-[1rem]"
}
const _hoisted_13 = {
  key: 0,
  className: "text-[0.875rem] text-[#fff] mr-[1.5rem] underline",
  href: "/video"
}
const _hoisted_14 = {
  key: 1,
  className: "h-[3rem] bg-[#fff] shadow-[0_0.25rem_0.625rem_0_rgba(0,0,0,0.08)] flex items-center justify-center relative z-[100]"
}

import { isH5 } from '@/const';
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderContent',
  setup(__props) {

const store = useStore()
const router = useRouter()
const route = useRoute()
const headerType = ref(0)
const user = computed(() => store.getters.userInfo)
const jumpIndex = () => {
  router.push('/')
}
const loginOut = () => {
  store.commit('user/SET_TOKEN', '')
  store.commit('user/SET_USER_INFO', {})
  window.location.href = '/'
}
watch(() => route.path, (newPath) => {
  console.log('newPath', newPath)
  headerType.value = 0
  if (newPath.includes('/account')) {
    headerType.value = 1;
  }
  if (newPath.includes('/video')) {
    headerType.value = 2
  }

}, {
  immediate: true
})

const jump = () => {
  if (!store.getters.token) {
    router.push('/account/signin')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_DownOutlined = _resolveComponent("DownOutlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isH5)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: "https://static-jp.theckb.com/static-asset/sellerstation/seller_logo2.png",
              alt: "",
              class: "h-[28px] cursor-pointer",
              onClick: jumpIndex
            }),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
            _cache[5] || (_cache[5] = _createElementVNode("a", {
              class: "text-[1rem] font-[800] cursor-pointer mr-[3rem] underline",
              href: "/video"
            }, " 過去開催講座アーカイブ ", -1)),
            (user.value?.loginName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[2] || (_cache[2] = _createElementVNode("img", {
                    src: "https://static-jp.theckb.com/static-asset/sellerstation/ava.png",
                    alt: "",
                    class: "w-[1.5rem] h-[1.5rem] mr-[0.5rem]"
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_5, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", null, "Welcome", -1)),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(user.value?.loginName), 1),
                      _createVNode(_component_DownOutlined, { class: "text-[#FFFFFFA6] text-[0.4375rem] ml-[0.1]" }),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _cache[0] || (_cache[0] = _createElementVNode("img", {
                            src: "https://static-jp.theckb.com/static-asset/sellerstation/ava.png",
                            alt: ""
                          }, null, -1)),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(user.value?.loginName), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("span", {
                            class: "text-[#00000073] leading-[2.28rem] mt-[0.25rem] cursor-pointer",
                            onClick: loginOut
                          }, " ログアウト ")
                        ])
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("img", {
                    src: "https://static-jp.theckb.com/static-asset/sellerstation/avator.png",
                    alt: "",
                    class: "w-[1.5rem] h-[1.5rem] mr-[0.5rem]"
                  }, null, -1),
                  _createElementVNode("div", { class: "text-[0.75rem] leading-[1rem]" }, [
                    _createElementVNode("div", null, "Welcome"),
                    _createElementVNode("a", {
                      href: "/account/signin",
                      class: "font-[800]"
                    }, " ログイン "),
                    _createElementVNode("span", null, "/"),
                    _createElementVNode("a", {
                      href: "/account/register",
                      class: "font-[800]"
                    }, " 新規登録 ")
                  ], -1)
                ]))]))
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          ([0, 2].includes(headerType.value))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("img", {
                  src: "https://static-jp.theckb.com/static-asset/sellerstation/just_logo.png",
                  alt: "",
                  className: "h-[1.75rem]",
                  onClick: jumpIndex
                }),
                _cache[6] || (_cache[6] = _createElementVNode("span", { className: "flex-1" }, null, -1)),
                ([0].includes(headerType.value))
                  ? (_openBlock(), _createElementBlock("a", _hoisted_13, " 過去開催講座アーカイブ "))
                  : _createCommentVNode("", true),
                _createElementVNode("img", {
                  src: "https://static-jp.theckb.com/static-asset/sellerstation/user_icon.png",
                  alt: "",
                  className: "w-[2rem]",
                  onClick: jump
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("img", {
                  src: "https://static-jp.theckb.com/static-asset/sellerstation/seller_logo.png",
                  alt: "",
                  className: "w-[8.62338rem]"
                }, null, -1)
              ]))]))
        ], 64))
  ]))
}
}

})